import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface SellAssetAdminPayload {
  uuid: string;
  clientId: string;
  price: number;
  soldAt: string;
  invoice?: File | null;
}

export const useSellAssetAdmin = (
  options?: UseMutationOptions<any, Error, SellAssetAdminPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["sellAssetAdmin"],
    mutationFn: async ({ uuid, invoice, ...data }: SellAssetAdminPayload) => {
      const formData = new FormData();
      formData.append("clientId", data.clientId);
      formData.append("price", String(data.price));
      formData.append("soldAt", data.soldAt);
      if (invoice) formData.append("invoice", invoice);
      return axiosInstance
        .post(`/investments/${uuid}/admin/sell`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa sprzedaż aktywa...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "sell-asset-admin",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Aktywo sprzedane pomyślnie.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "sell-asset-admin",
      });
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      queryClient.invalidateQueries({ queryKey: ["investments/admin/grouped"] });
      queryClient.invalidateQueries({ queryKey: ["investments/admin/clients"] });
      queryClient.invalidateQueries({ queryKey: ["investments/summary"] });
      queryClient.invalidateQueries({ queryKey: ["investments/admin/summary", "reliance"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas sprzedaży aktywa.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "sell-asset-admin",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
